import React from 'react';
import {
  ModalFloatingCloseBtn,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import { useTelemetry } from '@order/Telemetry';

import {
  CreditCardFormContent,
  useCreditCardHandlers,
} from '../../components/CreditCard';
import { PageWrapper } from '../../components/PageWrapper';
import { TransparentModal } from '../../components/TransparentModal';
import type { PaymentMethodAddScreenProps } from '../../navigation/AppNavigation.props';

export const PaymentMethodAddScreen = ({
  navigation,
}: PaymentMethodAddScreenProps): React.ReactElement => {
  const navigateBack = React.useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.getParent()?.goBack();
    }
  }, [navigation]);

  const {
    submitBillingAccountResponse,
    parseBillingAccountResponse,
    handleOnSave,
  } = useCreditCardHandlers({
    onComplete: navigateBack,
  });
  const isSubmitting = Boolean(submitBillingAccountResponse?.fetching);
  const submitCreditCardSuccess = Boolean(
    parseBillingAccountResponse(submitBillingAccountResponse?.data)
      ?.billingAccount?.id,
  );

  // ──────── Telemetry ─────────

  const { track } = useTelemetry();

  React.useEffect(() => {
    if (!submitCreditCardSuccess) return;

    track('checkout.add_card_success');
  }, [submitCreditCardSuccess, track]);

  const { isMobile } = useBreakpointHelpers();

  return (
    <TransparentModal size="small" onClose={navigateBack}>
      {isMobile ? null : <ModalFloatingCloseBtn onPress={navigateBack} />}
      <PageWrapper
        testID="account.add-credit-card.root.container"
        withHeaderTitle
        withoutFooter
      >
        <CreditCardFormContent
          vault="order"
          account={undefined}
          isVisible={true}
          isEditing={false}
          isSaving={isSubmitting}
          isDeleting={false}
          onSave={handleOnSave}
        />
      </PageWrapper>
    </TransparentModal>
  );
};
